const txt = [
  ["Могу я взять твой телефон?", "Can I borrow your phone?"],
  [
    "Мне нужно занять пять тысяч долларов в банке",
    "I need to borrow five thousand dollars from a bank",
  ],
  ["Можешь одолжить мне свой телефон?", "Can you lend me your phone"],
  ["Можешь одолжить мне 10$ ?", "Can you lend me ten bucks?"],
  ["Можешь одолжить мне это?", "Can you lend it to me?"],
  ["Ты должен мне 200$", "You owe me two hundred dollars"],
  ["Ты мне ничего не должен", "You owe me nothing"],
  ["Когда ты вернешь долг?", "When will you pay back?"],
  ["Отдашь, когда сможешь.", "Pay me back when you can"],
  ["Когда он тебе отдаст?", "When will he pay you back?"],
];

export default txt;
